/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, September 2020
 *
 *****************************************************************************/

import React from "react";
import { Polygon } from "@react-google-maps/api";
import { useSelector, shallowEqual } from "react-redux";

// show all polygons
const AllPolygons = ({ selectedPropertyId, selectProperty }) => {
  const geofenceData = useSelector(
    (state) => state.geofence.geofenceData,
    shallowEqual
  );
  let polygons = [];
  for (let property of geofenceData) {
    if (property.propertyId === selectedPropertyId) continue;
    for (let poly of property.geometries) {
      polygons.push(
        <Polygon
          onClick={selectProperty(property.propertyId)}
          key={poly.gid}
          editable={false}
          draggable={false}
          path={poly.path}
          options={{
            strokeColor: "red",
            fillColor: "darkgray",
            fillOpacity: 0.3,
          }}
        />
      );
    }
  }
  return polygons;
};

export default React.memo(AllPolygons);
